import React from "react";
import { Slot as SlotPrimitive } from "radix-ui";
import { useAnalytics } from "~/contexts/analytics-context";
import { Icon } from "~/components/icon/icon";
import { getButtonClasses } from "./button.utils";
import { ButtonProps } from "./button.types";

export const Button = ({
  id,
  variant = "primary",
  size = "medium",
  asChild,
  label,
  disabled = false,
  icon,
  iconPosition = "left",
  className = "",
  spanClassName = "",
  analyticsId,
  analyticsData = {},
  onClick,
  testId,
  iconClassName,
  autoFocus,
  type = "button",
  children,
  counter,
  counterTestId = "button-counter",
  ref,
  ...props
}: ButtonProps) => {
  const analytics = useAnalytics();

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (analyticsId && analytics?.gaEvent) {
      analytics.gaEvent({
        type: "click",
        payload: {
          analytics_id: analyticsId,
          ...analyticsData,
        },
      });
    }

    if (onClick) {
      return onClick(e);
    }
  };
  const Comp = asChild ? SlotPrimitive.Root : "button";
  // Always wrap button for consistent structure, whether counter is present or not
  return (
    <Comp
      ref={ref}
      type={type === "submit" ? "submit" : "button"}
      id={id}
      className={getButtonClasses({
        variant,
        size,
        disabled,
        className,
      })}
      autoFocus={autoFocus}
      disabled={disabled}
      data-testid={testId}
      onClick={handleClick}
      {...props}
    >
      {iconPosition === "left" && icon && (
        <Icon name={icon} size={size!} iconClassName={iconClassName} />
      )}
      {label && (
        <span className={`relative flex flex-row ${spanClassName}`}>
          {label}
        </span>
      )}
      {asChild ? (
        <SlotPrimitive.Slottable>{children}</SlotPrimitive.Slottable>
      ) : (
        children
      )}
      {counter !== undefined && counter > 0 && (
        <span
          className="ml-2 flex h-5 w-5 items-center justify-center rounded-full bg-white text-xs font-semibold text-primary shadow-sm ring-1 ring-secondary-200"
          data-testid={counterTestId}
        >
          {counter}
        </span>
      )}
      {iconPosition === "right" && icon && (
        <Icon name={icon} size={size!} iconClassName={iconClassName} />
      )}
    </Comp>
  );
};
